import $ from 'jquery';
import { defaultValue, makeText, setHtml } from './lib.js';

const defaultText = defaultValue(`There are no images in your<br>album yet.`);

export function show() {
  const emptyContentCssPath = '.empty-content';
  $(emptyContentCssPath).show();
}

export function setText(text = '') {
  const element = makeText('.empty-content__subtext');
  setHtml(defaultText(text), element);
}

export function hide() {
  const element = document.querySelector('.empty-content');
  if (element) {
    element.style.display = 'none';
  }
}
